module.exports = __webpack_public_path__ + "static/media/stakeDarkActive.f16cc043.svg";